import React from 'react';
import { Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { Intl } from 'components';

export default React.memo( ( {
  title, field, titleSize = 3, fieldSize = 6, className,
} ) => (
  <Row className={classnames( 'align-items-start', className )} style={{ marginBottom: 2 }}>
    <Col md={titleSize} className="pr-0">
      <div
        style={{ borderRight: '2px solid white' }}
        className="bg-gray-3 py-2 font-weight-bold text-sm px-2"
      >
        <Intl id={title} />
      </div>
    </Col>
    <Col md={fieldSize}>{field}</Col>
  </Row>
) );
